import createSagaMiddleware from 'redux-saga';

import { appSagas } from '!core/redux/app.sagas';

export const reduxSagasMiddleware = createSagaMiddleware();

export const runSagas = () => {
  reduxSagasMiddleware.run(appSagas);
};
